<template>
    <a
        v-if="link"
        :href="link"
        target="_blank"
        class="p-8 transition-colors cursor-pointer rounded-4 overflow-hidden flex items-center justify-center"
        :class="[bgClass]"
    >
        <svg-icon v-if="icon" :type="icon" :class="iconSizeClass" />
        <slot>{{ title }}</slot>
    </a>
    <div
        v-else
        class="p-8 cursor-default rounded-4 overflow-hidden flex items-center justify-center"
        :class="[bgClass]"
    >
        <svg-icon v-if="icon" :type="icon" :class="iconSizeClass" />
        <slot>{{ title }}</slot>
    </div>
</template>
<script>
import SvgIcon from './SvgIcon.vue';

export default {
    name: "BusinessAvatar",
    components: {
        SvgIcon,
    },
    props: {
        size: {
            type: String,
            default: 'small',
            validator: value => ['small', 'large'].includes(value),
        },
        icon: String,
        title: String,
        color: {
            type: String,
            default: 'primary',
        },
        link: String,
    },
    data() {
        return {
            iconSizes: {
                small: 'w-48 h-48',
                large: 'w-104 h-104',
            },
        }
    },
    computed: {
        iconSizeClass() {
            return this.iconSizes[this.size];
        },
        bgClass() {
            if (!this.color) return '';
            if (this.color.startsWith('#')) {
                return `bg-[${this.color}]`;
            } else {
                return `bg-${this.color}`;
            }
        }
    }
}
</script>
<style scoped>

</style>